export const MODULE_NAME = 'views/cottage-prices'

export const PRICES_STORE_ID = `${MODULE_NAME}/store`

export const ALIAS_PATH = '/__nuxt-pages/casa-rural/:province()/:slug()/precios'
